import { combineReducers } from 'redux';
import AuthReducer from './AuthReducer';
import UserProfileReducer from "./UserProfileReducer";
// import ProfileReducer from "./ProfileReducer";
const RootReducer = combineReducers({
    userAuth: AuthReducer,
    user:UserProfileReducer,
    // userDetails: ProfileReducer,
});
export default RootReducer;